import { Modal, TextBase, TextSubHeader } from '@carboncopyco/ui';
import { useFolderManageAccess } from './FolderManageAccessContext';
import { FolderManageAccessControls } from './FolderManageAccessControls';
import { FolderManageAccessList } from './FolderManageAccessList';
import { FolderManageAccessSearch } from './FolderManageAccessSearch';

export const FolderManageAccessModalBody = () => {
  const { isLoading, onClose, isOpen, folder } = useFolderManageAccess();
  return (
    <Modal
      open={isOpen}
      title={
        <div className="flex items-center">
          {!isLoading && (
            <TextSubHeader
              label={`Manage access for "${folder?.name}" folder`}
              color="text-ds-natural-600"
            />
          )}
        </div>
      }
      onClose={onClose}
    >
      <div className="flex flex-col gap-3 w-[560px] mt-3">
        <div>
          <div className="flex flex-col gap-6">
            <TextBase
              label="Workspace users with access can view and present resources within this folder, they cannot edit the original files."
              color="text-ds-natural-600"
            />
          </div>
        </div>

        <div className="w-full mt-4">
          <FolderManageAccessSearch />
          <FolderManageAccessList />
          <FolderManageAccessControls />
        </div>
      </div>
    </Modal>
  );
};
